import ProjectUtils from "../../../../../../utils/project-utils.js";

export function makeInitialInfoItems(data, boName) {
    const initialInfo = data?.dispatch ?? {};
    const hasGarrisonSupervision = Boolean(initialInfo?.garrison_supervision);

    return [
        {
            label: "Talão",
            value: initialInfo?.dispatch_numbercheckbook ?? "",
        },
        {
            label: "",
            value: " ",
        },
        {
            label: boName,
            value: initialInfo?.dispatch_occurrencenumber ?? "",
        },
        {
            label: "D/H inicial",
            value: ProjectUtils.formatDate(initialInfo?.dispatch_start ?? "", null, true),
        },
        {
            label: "",
            value: " ",
        },
        {
            label: "D/H final",
            value: ProjectUtils.formatDate(initialInfo?.dispatch_end ?? "", null, true),
        },
        {
            label: "Natureza",
            value: initialInfo?.dispatch_nature,
        },
        {
            label: "",
            value: " ",
        },
        {
            label: "Status",
            value: initialInfo?.dispatch_status ? "EM ANDAMENTO" : "ENCERRADO",
        },
        ...(hasGarrisonSupervision ? [
            {
                label: "Fiscalizando a guarnição",
                value: initialInfo?.garrison_supervision ?? "",
            },
        ] : []),
    ];
}

export function makeIndividualItems(data) {
    const initialInfo = data?.dispatch ?? {};

    return [
        {
            label: "Solicitante",
            value: initialInfo?.contactname ?? "",
        },
        {
            label: "Telefone",
            value: ProjectUtils.formatPhone(initialInfo?.contactphone ?? ""),
        },
        {
            label: "CPF",
            value: ProjectUtils.formatCpfToView(initialInfo?.contactcpf ?? ""),
        }
    ];
}

export function makeGarrisonItems(data) {
    const initialInfo = data?.dispatch ?? {};

    return [
        {
            label: "Guarnição",
            value: initialInfo?.garrison_name ?? "",
        },
        {
            label: "Contigentes",
            value: initialInfo?.contingent_namewar ?? "",
        },
        {
            label: "Animais",
            value: initialInfo?.animals ?? "",
        },
    ];
}